import { Link } from "react-router-dom";
import { Logo } from "./Logo";
import { FEATURES, featurePath } from "../../data/site";

const COLS = [
  { title: "Explore", links: [["Home", "/"], ["Meet Honesti", "/#meet-honesti"], ["Features", "/features"], ["Join Waitlist", "/waitlist"]] },
  { title: "Features", links: FEATURES.map((f) => [f.title, featurePath(f.slug)]) },
  { title: "Advanced Learning", links: [["Overview", "/advanced-learning"], ["HonestGrow™ University", "/advanced-learning/honestgrow-university"], ["Little Chefs Academy", "/advanced-learning/little-chefs-academy"]] },
];

export const Footer = () => (
  <footer data-testid="site-footer" className="relative border-t border-cyan-400/15 bg-deep">
    <div className="mx-auto grid max-w-[1440px] gap-12 px-5 py-16 lg:grid-cols-12 lg:px-12">
      <div className="lg:col-span-4">
        <Logo />
        <p className="mt-6 max-w-sm text-sm leading-relaxed text-slate-300">
          HonestChoice AI is a product concept. Pages marked “Demonstration” use sample data. Live features — meal ideas, Ask Honesti chat, your household profile and waitlist sign-ups — are real and clearly labelled.
        </p>
      </div>
      {COLS.map((c) => (
        <div key={c.title} className="lg:col-span-2 lg:first-of-type:col-start-6">
          <p className="eyebrow mb-5">{c.title}</p>
          <ul className="space-y-3">
            {c.links.map(([label, to]) => (
              <li key={label}><Link to={to} data-testid={`footer-link-${label.toLowerCase().replace(/[^a-z]+/g, "-")}`} className="text-sm text-slate-300 transition-colors hover:text-cyan-200">{label}</Link></li>
            ))}
          </ul>
        </div>
      ))}
    </div>
    <div className="border-t border-cyan-400/10">
      <div className="mx-auto flex max-w-[1440px] flex-col justify-between gap-2 px-5 py-6 text-xs text-slate-400 sm:flex-row lg:px-12">
        <span>© 2026 HonestChoice AI. Concept preview.</span>
        <span>One companion. Endless possibilities.</span>
      </div>
    </div>
  </footer>
);
